import React from "react";
import { Helmet } from "react-helmet";
import "./ErrorFallbackUI.css";
import logo from "../../../assets/shap_logo2.png";
export default function ErrorFallbackUI() {
 return (
  <div className="error-fallbackui">
   <Helmet>
    <title>An Error Occured | SHAP</title>
    <meta
     name="description"
     content="Knowledge-based digital products distribution at a premium"
    />
   </Helmet>
   <div className="error-fallbackui-card">
    <div className="logo-container">
     <img src={logo} alt="logo" />
    </div>

    <p className="error-fallbackui-title error">Site is temporary down</p>

    <p className="error-fallbackui-desc error">
     Dear esteemed customer, we are sorry to inform you that our site is
     temporary down due to technical issues, which our engineering team is
     already tackling. We are sorry for any inconvenices this might cause you.
    </p>
   </div>
  </div>
 );
}
